import { useEffect } from 'react';
import { DataGridPro, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { ContextMenu } from './ContextMenu';
import { useTranslation } from 'react-i18next';
import { usePayRulesTable } from 'hooks/payRules/usePayRulesTable';

const PayRuleTable = () => {
    const { t } = useTranslation();
    const { columns, rows, loading, contextMenu, selected, setContextMenu, setSelectedRow, selectedRow, setSelected, cleanSelected, reloading } = usePayRulesTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <div
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
            }}
        >
            <DataGridPro
                sx={{
                    height: 'calc(100vh - 140px)',
                    width: '100%',
                    cursor: 'default',
                    '& .MuiDataGrid-cell': {
                        cursor: 'pointer',
                    },
                }}
                pagination
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={(row) => row.id}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
                rowSelectionModel={selected}
                onRowSelectionModelChange={(newRowSelectionModel: GridRowSelectionModel) => {
                    let row = rows.filter((row: any) => newRowSelectionModel.includes(row.id));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                checkboxSelection
                slots={{
                    noRowsOverlay: () => (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
                            <strong>{'NO HAY DATOS EN LA TABLA'}</strong>
                        </div>
                    ),
                }}
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count) => (count > 1 ? `${count.toLocaleString()} filas seleccionadas` : `${count.toLocaleString()} fila seleccionada`),

                    footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                    MuiTablePagination: {
                        labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} of ${count === -1 ? `more than ${to}` : count}`,
                        labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                    },
                }}
                showCellVerticalBorder
                showColumnVerticalBorder
                disableColumnMenu
                headerFilters
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                disableMultipleRowSelection
            />
            <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selected={selectedRow} rows={rows} reloading={reloading} cleanSelected={cleanSelected} />
        </div>
    );
};

export { PayRuleTable };
